import React from 'react'
import classNames from 'classnames'
import styles from './ImageContainer.module.scss'
import Image from '../Image/Image'

const ImageContainer = ({ containerClass, imageClass, imageUrl }) => {
  return (
    <div className={classNames(styles['container'], containerClass)}>
      <Image
        src={imageUrl}
        className={classNames(styles['image'], imageClass)}
        alt="logo"
      />
    </div>
  )
}

export default ImageContainer
